module.exports = __webpack_public_path__ + "static/media/event_health_talk.e10a3d08.jpg";